import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CdsForm, CdsTypeaheadField, CdsDateField } from 'clayco-component-library';

const StayBenefitModalForm = ({
  showModal,
  closeModal,
  editMode,
  isSubmitting,
  canSave,
  savePeriod,
  stayBenefitSchema,
  handleFormError,
  formData,
  setFormData,
  setIsDirty,
  fieldErrors,
  projectOptions,
  projectLoading,
  calculateDays
}) => (
  <Modal show={showModal} onHide={closeModal} backdrop="static" size="md">
    <CdsForm onSubmit={savePeriod} schema={stayBenefitSchema} onError={handleFormError}>
      <Modal.Header closeButton>
        <Modal.Title>{editMode ? 'Edit Non-Travel Period' : 'Add Non-Travel Period'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <CdsTypeaheadField
            key={`projectAssignment-${Array.isArray(formData.projectAssignment) && formData.projectAssignment[0]?.value ? formData.projectAssignment[0].value : 'none'}`}
            label="Project Assignment"
            name="projectAssignment"
            required
            options={projectOptions}
            selectedOptions={Array.isArray(formData.projectAssignment) ? formData.projectAssignment : []}
            isLoading={projectLoading}
            placeholder="Search or enter project assignment"
            allowMultiple={false}
            submitButton={false}
            onChange={(selected) => {
              console.log('[StayBenefitModalForm] Typeahead onChange selected:', selected);
              // Normalize selected into array for validation consistency.
              const arr = Array.isArray(selected) ? selected : (selected ? [selected] : []);
              setFormData(prev => ({ ...prev, projectAssignment: arr }));
              setIsDirty(true);
            }}
          />
          {fieldErrors?.projectAssignment && <div className="text-danger small mt-1">{fieldErrors.projectAssignment}</div>}
        </div>
        <div className="mb-3">
          <CdsDateField
            label="Non-Travel Period Start Date"
            name="startDate"
            required
            initialDate={formData.startDate ? new Date(formData.startDate + 'T00:00:00') : null}
            minDate={new Date('2025-10-01T00:00:00')}
            maxDate={new Date()}
            showDays
            placeholder="MM/DD/YYYY"
            onChange={dateObj => {
              if (!(dateObj instanceof Date) || isNaN(dateObj)) return;
              const y = dateObj.getFullYear(), m = String(dateObj.getMonth() + 1).padStart(2, '0'), d = String(dateObj.getDate()).padStart(2, '0');
              setFormData(prev => ({ ...prev, startDate: `${y}-${m}-${d}` })); setIsDirty(true);
            }}
            onError={err => setFormData(prev => ({ ...prev, startDate: typeof err === 'string' ? err : err?.message }))}
          />
          {fieldErrors?.startDate && <div className="text-danger small mt-1">{fieldErrors.startDate}</div>}
        </div>
        <div className="mb-3">
          <CdsDateField
            label="Non-Travel Period End Date"
            name="endDate"
            required
            initialDate={formData.endDate ? new Date(formData.endDate + 'T00:00:00') : null}
            minDate={new Date('2025-10-01T00:00:00')}
            maxDate={new Date()}
            showDays
            placeholder="MM/DD/YYYY"
            onChange={dateObj => {
              if (!(dateObj instanceof Date) || isNaN(dateObj)) return;
              const y = dateObj.getFullYear(), m = String(dateObj.getMonth() + 1).padStart(2, '0'), d = String(dateObj.getDate()).padStart(2, '0');
              setFormData(prev => ({ ...prev, endDate: `${y}-${m}-${d}` })); setIsDirty(true);
            }}
            onError={err => setFormData(prev => ({ ...prev, endDate: typeof err === 'string' ? err : err?.message }))}
          />
          {fieldErrors?.endDate && <div className="text-danger small mt-1">{fieldErrors.endDate}</div>}
        </div>
        {(() => { const days = calculateDays(formData.startDate, formData.endDate); return days === '' ? null : (<div className="mb-2 fw-semibold">Days Without Travel: {days}</div>); })()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>Cancel</Button>
        <Button variant="primary" type="submit" disabled={isSubmitting || !canSave}>
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </CdsForm>
  </Modal>
);

export default StayBenefitModalForm;
